<template>
    <form @submit.prevent="update">
        <text-input
            v-model="editedBodyText"
            label="Uppgift"
            name="body"
            :autofocus="true"
        />

        <base-actions
            @update="update"
            @delete="deleteTask"
            @cancel="$emit('cancel', true)"
        />
    </form>
</template>
<script>
    import BaseEditComponent from './BaseEditComponent';
    import BaseActions from './BaseActions';

    export default {
        components: {
            BaseActions,
        },
        extends: BaseEditComponent,
        data() {
            return {
                editedBodyText: this.task.body,
            };
        },
    };
</script>